export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_curve2-2d14b781e6b34c3f99dbebcb0935b4c2.png";